@if (!!this.dataLoaded) {
  <div class="teacher-stories">
    <div class="student-info">
      <div class="align-top">
        <img src="{{ student.avatar }}" />
        <div class="user-info">
          <a class="spen-util-link break-word" [routerLink]="['/students/teacher/', student.id]">{{ student.name }}</a>
          <p class="class-name">{{ student.class_name }}{{ student.attendance_number }}番</p>
        </div>
      </div>
    </div>
    <app-tab-view [tabOptions]="tabOptions"></app-tab-view>
    @switch (currentTab) {
      @case ('grade_1') {
        <app-story-detail [grade]="'1'"></app-story-detail>
      }
      @case ('grade_2') {
        <app-story-detail [grade]="'2'"></app-story-detail>
      }
      @case ('grade_3') {
        <app-story-detail [grade]="'3'"></app-story-detail>
      }
      @case ('summary') {
        <app-story-detail></app-story-detail>
      }
    }
  </div>
} @else {
  <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
}
